import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "core-wrapper" }
const _hoisted_2 = { class: "slider-item" }
const _hoisted_3 = { class: "slide-text" }
const _hoisted_4 = { class: "slide-title" }
const _hoisted_5 = { class: "slide-desc" }
const _hoisted_6 = { class: "slide-img" }
const _hoisted_7 = ["src"]

import { onMounted, onUnmounted, onActivated, ref } from "vue";

import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.min.css";

import AlgorithmIcon from "@/assets/img/algorithm-icon.png";
import SourceIcon from "@/assets/img/source-icon.png";
import DrainageIcon from "@/assets/img/drainage-icon.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'coreAdvantage',
  setup(__props, { expose: __expose }) {

const modules = [Autoplay];

const coreSwiperRef = ref();

const tabs = ref();
const setSwiperRef = (swiper: any) => {
  coreSwiperRef.value = swiper;
};

const sliderContents = [
  {
    title:
      "结合车联数据诸如复位信号数据、熄火点、Tbox数据以及三方数据，进一步圈选人群精准推送线索。",
    desc: "",
    imgSrc: SourceIcon,
  },
  {
    title:
      "基于多数据源，构建保养识别模型、事故识别模型、推荐服务站模型等，精准推送相关线索。",
    desc: "",
    imgSrc: AlgorithmIcon,
  },
  {
    title:
      "服务站从被动等待顾客进店，转变为主动邀请客户进店，打造了新的引流模式，提升线索进店率。",
    desc: "",
    imgSrc: DrainageIcon,
  },
];

onMounted(() => {
  tabs.value = document.querySelectorAll(".core-ads-tab");

  // 添加tab点击事件
  tabs.value.forEach((tab: any, index: number) => {
    tab.addEventListener("click", () => {
      // console.log("index :>> ", index);
      coreSwiperRef.value.slideTo(index);
    });
  });
});

// 从第一页开始滑动
const slideRestart = () => {
  coreSwiperRef.value.slideToLoop(0);
};

// 页面滑动
const slideChange = (swiper: any) => {
  updateTabsStatus(swiper.realIndex);
};

// 更新tabs的状态
const updateTabsStatus = (realIndex: number) => {
  tabs.value &&
    tabs.value.forEach((tab: any, index: number) => {
      if (index === realIndex) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
};

onUnmounted(() => {
  // console.log("unmounted");
});

__expose({
  slideRestart,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"core-title\" data-v-dd7ae206>核心优势</div><div class=\"core-tabs\" data-v-dd7ae206><div class=\"core-ads-tab\" data-index=\"0\" data-v-dd7ae206><div class=\"tab-num\" data-v-dd7ae206>01</div><div class=\"tab-title\" data-v-dd7ae206>多渠道数据来源</div></div><div class=\"core-ads-tab\" data-index=\"1\" data-v-dd7ae206><div class=\"tab-num\" data-v-dd7ae206>02</div><div class=\"tab-title\" data-v-dd7ae206>多样化算法模型</div></div><div class=\"core-ads-tab\" data-index=\"2\" data-v-dd7ae206><div class=\"tab-num\" data-v-dd7ae206>03</div><div class=\"tab-title\" data-v-dd7ae206>创新型引流模式</div></div></div>", 2)),
    _createVNode(_unref(Swiper), {
      centeredSlides: "true",
      direction: "horizontal",
      slidesPerView: 1,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 1000,
      modules: modules,
      onSwiper: setSwiperRef,
      onSlideChange: slideChange
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sliderContents, (slide, index) => {
          return _createVNode(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(slide.title), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(slide.desc), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: slide.imgSrc
                  }, null, 8, _hoisted_7)
                ])
              ])
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})